import { UserState } from '../types/context';

export const getPersistableUserState = (
  state: UserState
): Omit<UserState, 'venueName' | 'venueNameStatus'> => {
  const {
    venueName: _venueName,
    venueNameStatus: _venueNameStatus,
    ...persistableState
  } = state;
  return persistableState;
};
